const answers = [
  'Each party hereby indemnifies, saves and holds harmless the other Party/Parties and their' +
    ' respective officers, directors, employees, licensees, and assigns, if applicable, from any and all' +
    ' third party claims, losses, damages, liabilities, costs and expenses (including reasonable, outside' +
    ' attorneys’ fees) which arise out of any breach by such Party of any warranty, representation or' +
    ' agreement made by such Party in this Agreement.',

  '<MEMBER> hereby indemnifies, saves and holds harmless the other Party/Parties' +
    ' and their respective officers, directors, employees, licensees, and assigns, if applicable, from' +
    ' any and all third party claims, losses, damages, liabilities, costs and expenses (including' +
    ' reasonable, outside attorneys’ fees) which arise out of any breach by <MEMBER>' +
    ' of any warranty, representation or agreement made by such Party in this Agreement.',

  'Intentionally omitted.',
];

export default (options) => {
  let content = '';
  let checked = true;

  if (options.field1 !== 1) {
    content = answers[options.field1];
  } else {
    if (options.field2) {
      content = answers[1].replace('<MEMBER>', options.name);
    } else {
      content = answers[1].replace(
        '<MEMBER>',
        `<i><u>&nbsp;&nbsp;select a member&nbsp;&nbsp;</u></i>`
      );
      checked = false;
    }
  }

  return {
    content,
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/Indemnification.js